import { useMap } from "react-leaflet";
import { useEffect } from "react";
import L from "leaflet";

import { convertOSGridToLatLng, isValidOSGridCoordinate } from "./OSGridUtils";

// Custom component to handle fitting bounds
export const FitBoundsToMarkers = ({ markers, gpsLogs }) => {
  const map = useMap();

  useEffect(() => {
    const validGpsCoordinates = [...gpsLogs, ...markers]
      .filter(
        (log) => log.coordinates && isValidOSGridCoordinate(log.coordinates)
      )
      .map((log) => convertOSGridToLatLng(log.coordinates));

    const allValidCoordinates = [...validGpsCoordinates];

    if (allValidCoordinates.length <= 0) return;

    try {
      const bounds = L.latLngBounds(
        allValidCoordinates.map((coord) => [coord.lat, coord.lng])
      );
      // If only one coordinate, set a default zoom level
      if (allValidCoordinates.length === 1) {
        map.setView(
          [allValidCoordinates[0].lat, allValidCoordinates[0].lng],
          15
        );
      } else {
        map.fitBounds(bounds, { padding: [50, 50] });
      }
    } catch (error) {
      console.error("Error fitting bounds:", error);
    }
  }, [gpsLogs, map, markers]);

  return null;
};
